import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql, Link } from 'gatsby'

import routes from '../config/routes'
import Button from '../styled/Button'
import FlexGrid from '../styled/FlexGrid'

function BlogShare(props = {}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
            author
          }
        }
      }
    `
  )

  function handleShare(event) {
    event.preventDefault()
    const url = `${site.siteMetadata.siteUrl}${props.path}`
    const text = `"${props.title}" by ${site.siteMetadata.author}`
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        url
      )}&text=${encodeURIComponent(text)}`
    )
  }

  return (
    <FlexGrid alignItems="center" justifyContent="center" gutter="l">
      <FlexGrid.Item mb={{ _: 'base', md: '0' }}>
        <Button as="a" href="#" onClick={handleShare}>
          Share on Twitter
        </Button>
      </FlexGrid.Item>
      <FlexGrid.Item>
        <Button as={Link} to={routes.blog.index} display="block" fontSize="s">
          View more posts
        </Button>
      </FlexGrid.Item>
    </FlexGrid>
  )
}

BlogShare.propTypes = {
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default BlogShare
